import { FC } from 'react';
import { Input, Select, Typography } from 'antd';
import { TelephoneNumber } from '#types';
import { COMMON_COUNTRY_CODES } from '#types/System.Parameters.types';
import FlexCol from '../../../atoms/FlexCol';

const { Text } = Typography;

/**
 * Props for the DetailedTelephoneForm component
 */
interface DetailedTelephoneFormProps {
  /** Current telephone value with components */
  telephoneValue: TelephoneNumber;
  /** Whether the form inputs are disabled */
  disabled?: boolean;
  /** Validation status for the inputs */
  status?: '' | 'error' | 'warning' | undefined;
  /** Callback when a telephone component changes */
  onComponentChange: (field: keyof NonNullable<TelephoneNumber['components']>, newValue: string) => void;
}

/**
 * Detailed telephone form for manual entry of telephone components.
 * Displays inputs for country code, phone number, and optional extension.
 */
const DetailedTelephoneForm: FC<DetailedTelephoneFormProps> = ({
  telephoneValue,
  disabled = false,
  status,
  onComponentChange
}) => {
  return (
    <FlexCol gap={10} style={{ width: 400, maxWidth: '90vw' }}>
      <FlexCol gap={0}>
        <Text>Country Code</Text>
        <Select
          value={telephoneValue.components?.countryCode || undefined}
          onChange={(newValue) => onComponentChange('countryCode', newValue)}
          disabled={disabled}
          status={status}
          placeholder="Select country code"
          options={COMMON_COUNTRY_CODES}
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          aria-label="telephone-countrycode-select"
          style={{ width: '100%' }}
        />
      </FlexCol>

      <FlexCol gap={0}>
        <Text>Phone Number</Text>
        <Input
          value={telephoneValue.components?.number || ''}
          onChange={(e) => onComponentChange('number', e.target.value)}
          disabled={disabled}
          status={status}
          placeholder="5551234567"
          aria-label="telephone-number-input"
        />
      </FlexCol>

      <FlexCol gap={0}>
        <Text>Extension (Optional)</Text>
        <Input
          value={telephoneValue.components?.extension || ''}
          onChange={(e) => onComponentChange('extension', e.target.value)}
          disabled={disabled}
          placeholder="123"
          aria-label="telephone-extension-input"
        />
      </FlexCol>
    </FlexCol>
  );
};

export default DetailedTelephoneForm;

